module.exports = __webpack_public_path__ + "media/B46.4cd9edca.mp3";